import { GridItem } from '@bnnvara/grids';
import { Heading, Text } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const NoTagsOrCategories = ({ message }) => (
  <Fragment>
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="1"
      columnEndMd="13"
    >
      <Heading element="h1" variant="brand">
        Geen resultaat...
      </Heading>
    </GridItem>
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="1"
      columnEndMd="13"
    >
      <Text>{message}</Text>
    </GridItem>
  </Fragment>
);

NoTagsOrCategories.propTypes = {
  message: PropTypes.string.isRequired,
};

export default NoTagsOrCategories;
